import { Component, Input, OnInit, TemplateRef } from "@angular/core";

@Component({
  selector: "nz-login",
  templateUrl: "./nz-login.component.html",
  preserveWhitespaces: false
})
export class NzLoginComponent implements OnInit {
  private _type = "primary";
  private _clientId;
  private _redirectUri;

  @Input()
  public set type(v: string) {
    this._type = v;
  }
  public get type(): string {
    return this._type;
  }

  @Input()
  public set clientId(v: string) {
    this._clientId = v;
  }

  public get clientId(): string {
    return this._clientId;
  }

  @Input()
  public set redirectUri(v: string) {
    this._redirectUri = encodeURIComponent(v);
  }

  public get redirectUri(): string {
    return this._redirectUri;
  }

  goto(): void {
    window.location.href =
      // tslint:disable-next-line:prefer-template
      "https://login.netease.com/connect/authorize?response_type=code&scope=openid+fullname+nickname&client_id=" +
      this.clientId +
      "&state=" +
      this.clientId +
      "/DOASi5_yD50lq0DwDMJiKNPf3j6KNbiPGZpPbrCogDeLzPOReYmG3a8wG_1rWA&redirect_uri=" +
      this.redirectUri;
  }

  ngOnInit(): void {
    // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    // Add 'implements OnInit' to the class.
  }
}
